<template>
  <vs-row vs-w="12">
    <vs-col vs-w="12">
      <vs-row vs-w="12" v-if="isLoadingProducts">
        <vs-col vs-w="12">
          <p class="opacity-60">Loading Products</p>
          <span class="flex h-12 w-12 mx-auto mt-5">
            <span
              class="
                animate-ping
                absolute
                inline-flex
                h-12
                w-12
                rounded-full
                bg-primary
                opacity-75
              "
            ></span>
            <span
              class="relative inline-flex rounded-full h-12 w-12 bg-primary"
            ></span>
          </span>
        </vs-col>
      </vs-row>

      <vs-row
        vs-w="12"
        v-if="!isLoadingProducts && (!products || products.length == 0)"
      >
        <vs-col vs-w="12">
          <p class="mt-2">
            <small>There are no products for this setup...</small>
          </p>
        </vs-col>
      </vs-row>

      <vs-row
        v-for="(product, index) of products"
        :key="'product-' + index"
      >
        <vs-col vs-w="12">
          <edit-single-product
            :product="product"
            @product-removed="handleSingleProductRemoved"
          ></edit-single-product>
        </vs-col>
      </vs-row>
      <vs-button @click="addProduct()" class="mt-6 mb-4"
        >Add a new product</vs-button
      >
    </vs-col>
  </vs-row>
</template>

<script>
import * as _ from "lodash";
import { mapGetters } from "vuex";
import EditSingleProduct from "./EditSingleProduct";

export default {
  components: {
    EditSingleProduct,
  },
  props: {
    setup: {
      type: Object,
    },
    products: {
      type: Array,
    },
    isLoadingProducts: {
      type: Boolean,
    },
  },
  model: {
    prop: "products",
    event: "products-changed",
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      activeVenueDetails: "marcom/activeVenue",
    })
  },
  methods: {
    handleSingleProductRemoved(product) {
      setTimeout(() => {
        let index = this.products.indexOf(product);
      this.products.splice(index, 1);
      }, 10);
    },
    addProduct() {
      this.products.splice(this.products.length, 1, {
        id: null,
        venueSetupId: {
          id: this.setup.id,
        },
        name: "",
        description: "",
        category: "other",
        image: "",
        isActive: true,
        unitPrice: {
          currency: this.activeVenueDetails.currencyInfo.isoCurrencySymbol,
          value: 0,
        },
      });
    },
  },
};
</script>
